/**
 * Initial state of the system.
 */
import {
    LOAD_METRICS_FOR_ZONE_CALL_BEGIN,
    LOAD_METRICS_FOR_ZONE_CALL_FAILURE,
    LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE,
    LOAD_STOW_ASSOCIATE_METRICS_FOR_ZONE,
    LOAD_STOW_PACKAGE_METRICS_FOR_NODE,
    LOAD_STOW_PACKAGE_METRICS_FOR_ZONE
} from "../actions/ZoneActions";


const initialState = {
    loading: true,
    inductPackageMetricsMap: {},
    stowAssociateMetricsMap: {},
    stowPackageMetricsMap: {},
    totalInductPackageMetrics: {},
    totalStowAssociateMetrics: {},
    totalStowPackageMetrics: {},
}


/**
 * Reducer function for Zone View that changes state
 * based on the action triggered.
 */
export default function zoneReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_METRICS_FOR_ZONE_CALL_BEGIN:
            return {
                ...state,
                loading: true
            }
        case LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalStowAssociateMetrics: action.totalStowAssociateMetrics
            }
        case LOAD_STOW_ASSOCIATE_METRICS_FOR_ZONE:
            return {
                ...state,
                loading: false,
                stowAssociateMetricsMap: action.stowAssociateMetricsMap
            };
        case LOAD_STOW_PACKAGE_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalStowPackageMetrics: action.totalStowPackageMetrics
            }
        case LOAD_STOW_PACKAGE_METRICS_FOR_ZONE:
            return {
                ...state,
                loading: false,
                stowPackageMetricsMap: action.stowPackageMetricsMap
            };
        case LOAD_METRICS_FOR_ZONE_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        default:
            return state;
    }
}






// WEBPACK FOOTER //
// ./src/reducers/ZoneReducer.js